<template>
  <div>
    <section class="my-teams-wrap clearfix">
      <div class="container">
        <div class="row">
          <section class="col-md-12">
            <!-- Toggle between Joined and Own Teams -->
            <div class="team-filter-tabs mb-4">
              <button
                @click="toggleTeamType(false)"
                :class="{ active: !showOwnTeams }"
                class="btn"
              >
                Joined Teams
              </button>
              <button
                @click="toggleTeamType(true)"
                :class="{ active: showOwnTeams }"
                class="btn"
              >
                My Teams
              </button>
            </div>

            <TeamList
              :teams="myTeams"
              :loading="loading"
              :pagination="pagination"
              :team-detail-base-url="teamDetailBaseUrl"
              :is-my-teams="true"
              @page-changed="handlePageChange"
            />
          </section>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import TeamList from "@/components/team/TeamList";

export default {
  name: "MyTeams",

  components: {
    TeamList,
  },

  data() {
    return {
      showOwnTeams: false,
      teamDetailBaseUrl: process.env.VUE_APP_TEAM_DETAIL_URL || "",
    };
  },

  computed: {
    ...mapGetters("team", ["myTeams", "loading", "pagination"]),
  },

  mounted() {
    this.loadTeams();
  },

  methods: {
    loadTeams(page = 1) {
      this.$store.dispatch("team/fetchMyTeams", {
        type: "all",
        ownTeams: this.showOwnTeams,
        page,
        limit: 15,
      });
    },

    toggleTeamType(isOwn) {
      this.showOwnTeams = isOwn;
      this.loadTeams(1);
    },

    handlePageChange(page) {
      this.loadTeams(page);
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
  },
};
</script>

<style scoped>
.team-filter-tabs button {
  margin-right: 10px;
  padding: 10px 20px;
}

.team-filter-tabs button.active {
  background-color: #007bff;
  color: white;
}
</style>
